import React, { useState } from 'react';
import { Box, TextField, Typography, Button, CircularProgress } from '@mui/material';
import apiInstance from '../../api/api';
import apiEndpoints from '../../utils/api/endpoints';

interface LoginPageTProps {
  onLoginSuccess: () => void;
}

const LoginPageT: React.FC<LoginPageTProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await apiInstance.post(apiEndpoints.kozelBattleTLogin, {
        username,
        password,
      });
      if (response.data?.success) {
        sessionStorage.setItem('kozelBattleTAuth', 'true');
        onLoginSuccess();
      } else {
        setError('Credențiale invalide.');
      }
    } catch {
      setError('Credențiale invalide.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#1a0a00',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: '#2a1500',
          border: '2px solid #D1A85E',
          borderRadius: '12px',
          padding: { xs: '32px 24px', sm: '48px 56px' },
          width: '100%',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          textAlign: 'center',
        }}
      >
        <Typography sx={{ color: '#D1A85E', fontSize: '1.8rem', fontWeight: 'bold', letterSpacing: 2 }}>
          KOZEL BATTLE
        </Typography>

        <TextField
          fullWidth
          placeholder="Utilizator"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="off"
          sx={{
            backgroundColor: '#f5e8c9',
            borderRadius: '4px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiInputBase-input': { color: '#4a3824', fontWeight: 'bold', textAlign: 'center' },
          }}
        />

        <TextField
          fullWidth
          type="password"
          placeholder="Parolă"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="off"
          sx={{
            backgroundColor: '#f5e8c9',
            borderRadius: '4px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiInputBase-input': { color: '#4a3824', fontWeight: 'bold', textAlign: 'center' },
          }}
        />

        {error && (
          <Typography sx={{ color: '#ff1744', fontSize: '0.9rem' }}>
            {error}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: '#D1A85E',
            color: '#1a0a00',
            fontWeight: 'bold',
            fontSize: '1rem',
            padding: '12px',
            '&:hover': { backgroundColor: '#ffffff' },
          }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: '#1a0a00' }} /> : 'INTRĂ'}
        </Button>
      </Box>
    </Box>
  );
};

export default LoginPageT;